import { setRuntimeAlias } from "@ui5/webcomponents-base/dist/Runtimes.js";

setRuntimeAlias("UI5 Web Components Playground");
